import { render, staticRenderFns } from "./OrderItemsTable.vue?vue&type=template&id=2966d7d0&scoped=true&"
import script from "./OrderItemsTable.vue?vue&type=script&lang=js&"
export * from "./OrderItemsTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderItemsTable.vue?vue&type=style&index=0&id=2966d7d0&lang=scss&scoped=true&"
import style1 from "./OrderItemsTable.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2966d7d0",
  null
  
)

export default component.exports